<template>
    <ac-modal title="Account Termination" ref="modal" :size-class="'modal-lg'" @ac-modal-closed="cancelPromise">
        <template>
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <p>You are about to terminate your account. Please Note:</p>
                        <i>If you have a plan selection:</i>
                        <ul>
                            <li>- All members under this account will be terminated.</li>
                            <li>- Your provider(s) will be notified.</li>
                            <li>- Your plan will remain active until the end of your membership 
                                duration and you will have limited access to your account.</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="margin-content">
                        <label>
                            Termination Date
                            <small><span class="redText"> required </span></small>
                        </label><br/>
                        <ac-date-picker v-model="participantTerminationData.effectiveDate"></ac-date-picker>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="margin-content">
                        <label>
                            Feedback
                        </label><br/>
                        <textarea class="form-control form-long-field" rows="4" 
                            placeholder="Would you mind telling us why you are leaving?" 
                            v-model="participantTerminationData.feedback"></textarea>
                    </div>
                </div>
                <div class="col-md-12" style="text-align: right;">
                    <ac-button class="btn btn-red btn-sm" :action="closeModal">CANCEL</ac-button>
                    <ac-button class="btn btn-green btn-sm" :action="terminateParticipant">TERMINATE ACCOUNT</ac-button>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {SelfTerminationClass} from "./SelfTerminationClass.js";
    import {formatter} from "../../../global/formatter.js"
    import {notifications} from "../../../global/notifications.js";

    export default {
        name: "SelfTerminationModal",
        props: {
            terminationAction: {
                type: SelfTerminationClass,
                required: true
            },
        },
        data() {
            return {
                participantTerminationData: {
                    effectiveDate: "",
                    feedback: "",
                    consumerId: this.terminationAction.consumerId
                },
                resolveRef: null
            }
        },
        methods: {
            async showModal() {
                this.init();
                return new Promise((resolve, reject) => {
                    this.resolveRef = resolve;
                });
            },
            init() {
                this.$refs.modal.open();
                this.participantTerminationData.effectiveDate = formatter.formatRawDate(new Date(), true);
            },
            closeModal() {
                this.$refs.modal.close();
            },
            async terminateParticipant() {
                if (!this.validate()) return;

                let result = await this.terminationAction.terminateParticipant(this.participantTerminationData);

                if (result) {
                    this.resolveRef(true);
                    this.closeModal();
                }
            },
            validate() {
                if (this.participantTerminationData.effectiveDate) return true;

                notifications.showError({title: "Error", message: "Please select a termination date"});
            },
            cancelPromise() {
                this.resolveRef(false);
            }
        }
    }
</script>

<style scoped>
    .margin-content {
        margin-bottom: 15px;
    }
</style>